/* eslint-disable no-param-reassign */
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

export const fetchFlexibleWork = createAsyncThunk(
  'fetchFlexibleWork',
  async () => {
    // this is what we need when we add authentication back
    const jwtToken = localStorage.getItem('myrJwtToken')
    const rcpid = localStorage.getItem('rcpid')
    const jobs = await axios.get(process.env.REACT_APP_FLEXIBLEWORK_ENDPOINT, {
      headers: {
        JWT: jwtToken,
        XWT: rcpid,
      },
    })
    return jobs.data
  },
)

const initialState = {
  status: 'idle',
  data: {
    title: 'My Flexible Work',
    information: {},
    links: [],
  },
}

const flexibleWorkSlice = createSlice({
  name: 'flexibleWorkWidget',
  initialState,
  reducers: {},
  extraReducers: {
    [fetchFlexibleWork.rejected]: (state) => {
      state.status = 'error'
    },
    [fetchFlexibleWork.pending]: (state) => {
      state.status = 'pending'
    },
    [fetchFlexibleWork.fulfilled]: (state, action) => {
      state.status = 'fulfilled'
      const filteredPayload = action.payload?.jobs?.filter(
        (job) => job.requestStatus !== 'WDRN',
      )
      state.data.links = action.payload?.linkList
      filteredPayload?.sort((a, b) => b.requestNumber - a.requestNumber)
      if (filteredPayload) {
        state.data.information = {
          ...action.payload,
          jobs: [filteredPayload[0]],
        }
      } else {
        state.data.information = {
          ...action.payload,
          jobs: filteredPayload,
        }
      }
    },
  },
})

export const selectFlexibleWorkData = (state) => state.flexibleWork.data
export const selectFlexibleWorkStatus = (state) => state.flexibleWork.status

export default flexibleWorkSlice.reducer
